import { useId } from 'react'

/**
 * Terysling's nine-dot diamond, based on the operator-supplied mark.
 * Transparent and deliberately unmirrored; branding.css owns its theme paint.
 * The accent fallbacks also serve consumers that copy this self-contained
 * component without the branding sheet (the imaging viewer).
 * Decorative because the product name always stands beside it.
 */
export function BrandEmblem({ className }: { className?: string }) {
  const paint = `${useId()}-dots`
  return (
    <svg className={`brand-emblem${className ? ` ${className}` : ''}`} viewBox="0 0 64 64" aria-hidden focusable="false">
      <defs>
        <linearGradient id={paint} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="var(--brand-emblem-start, var(--accent, #169cdd))" />
          <stop offset="1" stopColor="var(--brand-emblem-end, var(--accent-strong, #2260cf))" />
        </linearGradient>
      </defs>
      <g fill={`url(#${paint})`}>
        <circle cx="32" cy="8" r="5.5" />
        <circle cx="20" cy="20" r="5.5" />
        <circle cx="44" cy="20" r="5.5" />
        <circle cx="8" cy="32" r="5.5" />
        <circle cx="32" cy="32" r="5.5" />
        <circle cx="56" cy="32" r="5.5" />
        <circle cx="20" cy="44" r="5.5" />
        <circle cx="44" cy="44" r="5.5" />
        <circle cx="32" cy="56" r="5.5" />
      </g>
    </svg>
  )
}
